(function(){
  function enhance(scope){
    var root=scope.matches&&scope.matches('[data-bm-article]')?scope:scope.querySelector('[data-bm-article]');
    if(!root||root.dataset.bmArticleReady)return;
    root.dataset.bmArticleReady='true';
    var body=root.querySelector('[data-bm-article-body]'),title=root.querySelector('.article-title');
    if(!body||!title)return;
    function normalized(text){return text.replace(/\s+/g,' ').trim().toLowerCase();}
    var firstHeading=body.querySelector('h1,h2,h3,h4');
    if(firstHeading&&firstHeading.tagName==='H1'&&normalized(firstHeading.textContent)===normalized(title.textContent))firstHeading.hidden=true;
    var details=root.querySelector('[data-bm-article-toc]'),list=details&&details.querySelector('ol');
    var headings=Array.prototype.filter.call(body.querySelectorAll('h2'),function(h){return !h.hidden&&h.textContent.trim();});
    if(!list||headings.length<3)return;
    headings.forEach(function(heading,index){
      if(!heading.id){var id='bm-article-'+root.dataset.articleId+'-heading-'+(index+1);while(document.getElementById(id))id+='-section';heading.id=id;}
      var item=document.createElement('li'),link=document.createElement('a');link.href='#'+encodeURIComponent(heading.id);link.textContent=heading.textContent.trim();item.appendChild(link);list.appendChild(item);
    });
    details.hidden=false;
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){enhance(document);});else enhance(document);
  document.addEventListener('shopify:section:load',function(event){enhance(event.target);});
})();
